<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<h1 class="center">A Perfect Scoundrel</h1>
<h3 class="center" style="margin-top:60px;">Heather Cullman</h3>
<p class="center" style="margin-top:80px;"><img alt="image" src="image/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Untitled1.vue?516da1ec